import { Injectable }    from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../login/auth.service';
import { Filter } from '../../../helpers/tableview';

@Injectable()
export class AdminDashboardService {

    private headers: Headers;
    private url = environment.apiUrl;

    /*constructor(private http: Http, private authService: AuthService, private toastyService:ToastyService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }*/
    constructor(private http: Http, private authService: AuthService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
      }

    // API function call for getting static devices that are offline, based on city
    public findStaticOfflineDevices(filter: Filter): Promise<any> {
        return this.http
          .post(this.url+'/admin/getoffstaticdevices', filter, {headers: this.headers})
          .toPromise()
          .then(res => { return {items: res.json().devices, total: res.json().total}})
          .catch(this.handleError);
    }

    // API function call to get info on static device
    getTimeslotsOccupancy(dates: Array<string>, devices: Array<any> ): Promise<any>{
      let params = new URLSearchParams();
      
      dates.forEach(date => {
        params.append('dates[]', date);
      });
  
      devices.forEach(device => {
        params.append('devices[]', device.id);
      });
      
      //?date_from=2017-11-01&date_to=2017-11-03&regions[]=1&regions[]=2
      let options = new RequestOptions({ headers: this.headers, params: params }); 
      return this.http
        .get(this.url+'/admin/getstaticdeviceinfo', options)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/dashboard/dashboard.service.ts